import { MidwayIdentityCredentialProvider } from "@amzn/midway-identity-credential-provider";
import { AuthConfig, UserIdentity } from "./types";
import { AwsCredentialIdentity } from "@aws-sdk/types";
import { logging } from "src/core/util/log";
import { parseJwt } from "src/core/util/jwt";

export interface AuthControllerProps {
  authConfig: AuthConfig;
}
export class AuthController {
  readonly authConfig: AuthConfig;
  credentials: AwsCredentialIdentity | undefined;

  constructor(props: AuthControllerProps) {
    this.authConfig = props.authConfig;
  }

  /**
   * Returns the credentials provider associated with given AWS account
   * @param {*} clientConfig
   * @return {*}
   * @memberof AuthController
   * @see {@link https://code.amazon.com/packages/MidwayIdentityCredentialProvider/trees/mainline}
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public async getCredentialsProvider(clientConfig: any) {
    const midwayCredentials = MidwayIdentityCredentialProvider.newProvider({
      ...clientConfig,
      midwayIdentity: {
        cognitoIdentityPoolId: this.authConfig.identityPoolId,
      },
    });
    this.credentials = midwayCredentials;

    if (midwayCredentials.needsRefresh()) {
      await midwayCredentials.getPromise();
    }

    return midwayCredentials;
  }
  /**
   * Returns the user credentials via Midway authentication
   *
   * @return {*}  {Promise<UserIdentity>}
   * @memberof AuthController
   */
  public async getUserIdentity(): Promise<UserIdentity> {
    try {
      /*
       * Midway gives us a JWS Token - we can parse it to get the username
       * This does not validate the signature so it is not secure.
       * We should send this token to the backend so they can verify during permission control
       */
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const midwayCredentials: any = this.credentials;
      const jwt = parseJwt(
        midwayCredentials.params.Logins["midway-auth.amazon.com"],
      );
      const username = jwt.sub;

      logging.log("username: ", username);
      return {
        username: username,
        accessToken: "midway-auth.amazon.com",
      };
    } catch (error) {
      throw error;
    }
  }
}